export const data = [
  {
    name: "Kareem Abdul-Jabbar",
    img: "https://s22928.pcdn.co/wp-content/uploads/2018/03/Kareem-Abdul-Jabbar.jpg",
    statistics: [
      "38,387 points",
      "17,440 rebaunds",
      "5,660 assist",
      "19 All Star",
    ],
  },
  {
    name: "Larry Bird",
    img: "https://images.footballfanatics.com/boston-celtics/larry-bird-boston-celtics-unsigned-driving-to-the-basket-photograph_pi4025000_ff_4025713-3a32778de9bb567994e1_full.jpg?_hv=2&w=900",
    statistics: [
      "21,791 points",
      "8,974 rebaunds",
      "5,695 assist",
      "12 All Star",
    ],
  },
  {
    name: "Wilt Chamberlain",
    img: "https://pbs.twimg.com/media/EQwzU_RXUAAAATG?format=jpg&name=4096x4096",
    statistics: [
      "31,419 points",
      "23,924 rebaunds",
      "4,643 assist",
      "13 All Star",
    ],
  },
  {
    name: "Magic Johnson",
    img: "https://cdn.britannica.com/27/189527-050-5BAD12C2/Magic-Johnson.jpg",
    statistics: [
      "17,707 points",
      "6,559 rebaunds",
      "10,141 assist",
      "12 All Star",
    ],
  },
  {
    name: "Michael Jordan",
    img: "https://cdn.europosters.eu/image/1300/posters/michael-jordan-i116434.jpg",
    statistics: [
      "32,292 points",
      "6,672 rebaunds",
      "5,633 assist",
      "14 All Star",
    ],
  },
  {
    name: "Karl Malone",
    img: "https://i.pinimg.com/564x/49/76/10/497610981fdbe0158ba09b5c8418d87d--nba-players-basketball-players.jpg",
    statistics: [
      "36,928 points",
      "14,968 rebaunds",
      "5,248 assist",
      "14 All Star",
    ],
  },
  {
    name: "Hakeem Olajuwon",
    img: "https://cdn.artphotolimited.com/images/60913d60bd40b85323893a87/1000x1000/hakeem-olajuwon-von-den-houston-rockets.jpg",
    statistics: [
      "26,946 points",
      "13,748 rebaunds",
      "3,058 assist",
      "12 All Star",
    ],
  },
  {
    name: "Shaquille O'Neal",
    img: "https://staticg.sportskeeda.com/editor/2018/10/6bb16-15398694878129-800.jpg",
    statistics: [
      "28,596 points",
      "13,099 rebaunds",
      "3,026 assist",
      "15 All Star",
    ],
  },
  {
    name: "Scottie Pippen",
    img: "https://basketballforever.com/wp-content/uploads/2020/04/Scottie-Pippen-Chicago-Bulls.jpg",
    statistics: [
      "18,940 points",
      "7,494 rebaunds",
      "6,135 assist",
      "7 All Star",
    ],
  },
  {
    name: "Patrick Ewing",
    img: "https://cdn.britannica.com/37/231237-050-0CB78D66/Patrick-Ewing-New-York-Knicks-1986.jpg",
    statistics: [
      "24,815 points",
      "11,607 rebaunds",
      "2,215 assist",
      "11 All Star",
    ],
  },
  {
    name: "Kobe Bryant",
    img: "https://upload.wikimedia.org/wikipedia/commons/9/96/Kobe_Bryant_8.jpg",
    statistics: [
      "33,643 points",
      "7,047 rebaunds",
      "6,306 assist",
      "18 All Star",
    ],
  },
  {
    name: "Charles Barkley",
    img: "https://freshairarchive.org/sites/default/files/styles/square_800/public/2021-08/CharlesBarkley.jpg?itok=lkOGUQ2t",
    statistics: [
      "23,757 points",
      "12,546 rebaunds",
      "4,215 assist",
      "11 All Star",
    ],
  },
];
